import { useQuery } from '@tanstack/react-query';
import { getPendingActions, type PendingInvitation, type PendingContract } from '../api/pending-actions.ts';
import { useTokenStore } from '../api/use-api.ts';
import { useAuth } from '../lib/auth-context.tsx';
import { useMe } from '../lib/use-me.ts';

export type PendingActionsPanelState = {
  invitations: PendingInvitation[];
  contracts: PendingContract[];
  isLoading: boolean;
};

export function usePendingActionsState(): PendingActionsPanelState {
  const store = useTokenStore();
  const { accessToken, bootstrapped } = useAuth();
  const me = useMe();

  const enabled = bootstrapped && !!accessToken && me.data?.emailVerified === true;

  const pendingQ = useQuery({
    queryKey: ['me', 'pending-actions'],
    queryFn: () => getPendingActions(store),
    enabled,
    staleTime: 15_000,
  });

  return {
    invitations: pendingQ.data?.invitations ?? [],
    contracts: pendingQ.data?.contracts ?? [],
    isLoading: enabled && pendingQ.isLoading,
  };
}
